<template>
  <v-dialog v-model="localValue" width="700px">
    <v-card>
      <v-card-title>Salvar novo template de e-mail</v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col class="pb-0">
            <v-text-field v-model="title" placeholder="Nome do template" label="Nome do template" outlined no-resize :error-messages="errorTitle" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <mf-action-buttons
          class="pb-1"
          :primary-button="{
            text: 'Criar template',
            action: createEmailTemplate,
            isVisible: true,
            isLoading: loadingCreatingTemplate,
          }"
          :secondary-button="{
            text: 'Cancelar',
            action: close,
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { MUTATE_UPSERT_TEMPLATE } from '@/modules/campanhas/campanhas-email/graphql'

export default {
  props: {
    value: {
      type: Boolean,
    },
    templateGetter: {
      type: Function,
      required: true,
    },
  },

  data: () => ({
    lazyValue: false,
    loadingCreatingTemplate: false,
    title: '',
  }),

  computed: {
    errorTitle() {
      if (!this.$v.title) return ''
      if (this.$v.title.$error) {
        if (!this.$v.title.required) return 'Dê um nome para este template.'
        else if (!this.$v.title.minLength) return 'O nome possui menos de 2 caracteres.'
        else if (!this.$v.title.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    localValue: {
      get() {
        return this.lazyValue
      },
      set(value) {
        this.lazyValue = value
        this.$emit('input', value)
      },
    },
  },

  watch: {
    value(value) {
      this.lazyValue = value
    },
  },

  mounted() {
    this.lazyValue = this.value
  },

  methods: {
    async createEmailTemplate() {
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$error) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        return
      }
      const configuration = await this.templateGetter()
      try {
        this.loadingCreatingTemplate = true
        await this.$apollo.mutate({
          mutation: MUTATE_UPSERT_TEMPLATE,
          variables: {
            data: {
              title: this.title,
              configuration: configuration,
            },
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
        })
        this.$snackbar({ message: 'Template de e-mail criado com sucesso.', snackbarColor: 'success' })
        this.localValue = false
      } catch (e) {
        console.warn(e)
        this.$snackbar({ message: 'Falha ao criar o template de e-mail.', snackbarColor: 'error' })
      } finally {
        this.loadingCreatingTemplate = false
      }
    },
    close() {
      this.localValue = false
    },
  },

  validations: {
    title: {
      required,
      minLength: minLength(2),
      notOnlySpace,
    },
  },
}
</script>
